/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserWalletHistoryListRespVo
 */
export interface UserWalletHistoryListRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof UserWalletHistoryListRespVo
     */
    id?: number;
    /**
     * 用户 ID，关联用户表主键
     * @type {number}
     * @memberof UserWalletHistoryListRespVo
     */
    userId?: number;
    /**
     * 用户账号
     * @type {string}
     * @memberof UserWalletHistoryListRespVo
     */
    userAccount?: string;
    /**
     * 用户名称
     * @type {string}
     * @memberof UserWalletHistoryListRespVo
     */
    userName?: string;
    /**
     * 钱包 ID，关联用户钱包表主键
     * @type {number}
     * @memberof UserWalletHistoryListRespVo
     */
    walletId?: number;
    /**
     * 钱包类型：1-韩国钱包，2-中国账单钱包
     * @type {number}
     * @memberof UserWalletHistoryListRespVo
     */
    walletType?: number;
    /**
     * 货币代码，如 CNY、USD、KRW 等
     * @type {string}
     * @memberof UserWalletHistoryListRespVo
     */
    currencyCode?: string;
    /**
     * 出入金额
     * @type {number}
     * @memberof UserWalletHistoryListRespVo
     */
    amount?: number;
    /**
     * 出入金之后的钱包余额
     * @type {number}
     * @memberof UserWalletHistoryListRespVo
     */
    principal?: number;
    /**
     * 出金入金类型：0-出金，1-入金
     * @type {number}
     * @memberof UserWalletHistoryListRespVo
     */
    intOutType?: number;
    /**
     * 备注说明
     * @type {string}
     * @memberof UserWalletHistoryListRespVo
     */
    remark?: string;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof UserWalletHistoryListRespVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof UserWalletHistoryListRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof UserWalletHistoryListRespVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the UserWalletHistoryListRespVo interface.
 */
export function instanceOfUserWalletHistoryListRespVo(value: object): value is UserWalletHistoryListRespVo {
    return true;
}

export function UserWalletHistoryListRespVoFromJSON(json: any): UserWalletHistoryListRespVo {
    return UserWalletHistoryListRespVoFromJSONTyped(json, false);
}

export function UserWalletHistoryListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWalletHistoryListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userAccount': json['userAccount'] == null ? undefined : json['userAccount'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'walletId': json['walletId'] == null ? undefined : json['walletId'],
        'walletType': json['walletType'] == null ? undefined : json['walletType'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'principal': json['principal'] == null ? undefined : json['principal'],
        'intOutType': json['intOutType'] == null ? undefined : json['intOutType'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function UserWalletHistoryListRespVoToJSON(json: any): UserWalletHistoryListRespVo {
    return UserWalletHistoryListRespVoToJSONTyped(json, false);
}

export function UserWalletHistoryListRespVoToJSONTyped(value?: UserWalletHistoryListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'userAccount': value['userAccount'],
        'userName': value['userName'],
        'walletId': value['walletId'],
        'walletType': value['walletType'],
        'currencyCode': value['currencyCode'],
        'amount': value['amount'],
        'principal': value['principal'],
        'intOutType': value['intOutType'],
        'remark': value['remark'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

